import React from 'react';

//component
import WmsModel from '../../../../components/WmsModel/WmsModel.jsx';
import VirtualGridComponent from '../../../../components_proto/VirtualGridComponent/VirtualGridComponent.jsx';
import WmsButton from '../../../../components/WmsButton/WmsButton.jsx';
import WmsDropdown from '../../../../components/WmsDropdown/WmsDropdown.jsx';

import './reprint-end-of-day-reoprt.scss';
import * as GlobalService from './../../../../global_services';
import * as findOrdersService from './../../findOrders.services.jsx';
import axios from 'axios';

export class ReprintEODReport extends React.Component {

    constructor(props) {

        super(props);

        this.translate = window.translate;

        this.state = {
            selector: "reprintEndOfDay",
            faciltyOptions: GlobalService.getFacilityList(),
            endOfDayNickName: "",
            selectedFacilityId: "",
            selectedWarehouse: "",
            nickNameOption: [],
            gridResourceList: [],
            selectedPrintedItem: 0,
            isRefreshLoading: false,
            isGridLoading: false,
            gridColumns: [{
                field: "CreationDate",
                title: "Created On",
                width: "100%",
                wmsid: 1,
                template: "#= CreationDate != null ? (moment(CreationDate).format('MMMM Do, YYYY hh:mm a')) : '' #"
            }, {
                field: "Shipments",
                title: "Order count",
                width: 200,
                wmsid: 2
            }, {
                field: "CarrierAccountNickname",
                title: "Account Nickname",
                width: 200,
                wmsid: 3
            }]
        }
    }

    componentDidMount() {
        kendo.ui.progress($('#reprintEndOfDayReport'), true);
        axios.get('/WebUI/Settings/CarrierAccount/GetCarrierAccounts?customerUri=all')
            .then((response) => {
                const removeNullArray = response.data.filter((item) => item.NickName);
                const uniqNickName = _.uniqBy(removeNullArray, (elem) => `${elem.NickName}-${elem.ShipEngineId}`);
                uniqNickName.push({
                    NickName: "All",
                    ShipEngineId: "all"
                });
                const defaultShipEngineId = uniqNickName.length > 0 ? uniqNickName[0].ShipEngineId : "";

                this.setState({
                    nickNameOption: uniqNickName,
                    endOfDayNickName: defaultShipEngineId
                });
            })
            .catch((error) => {
                console.error('Error fetching carrier accounts:', error);
            })
            .finally(() => {
                kendo.ui.progress($('#reprintEndOfDayReport'), false);
            });
    }

    getIdByName = (name) => {
        const facility = this.state.faciltyOptions.find((element) => element.name === name);
        return facility ? facility.id : "";
    }
    changeWarehouse = (event) => {
        const warehouseValue = event.target.value;
        const selectedFacilityId = this.getIdByName(warehouseValue);

        this.setState({
            selectedWarehouse: warehouseValue,
            selectedFacilityId: selectedFacilityId
        }, this.getGridData);
    }
    changeNickName = (e) => {
        this.setState({
            endOfDayNickName: e.target.value
        }, this.getGridData);
    }

    refreshReprintManifest = () => {
        this.setState({ isRefreshLoading: true });
        findOrdersService.manifestList()
            .then((response) => {
                if (response.status === 200) {
                    this.getGridData();
                }
            })
            .catch((error) => {
                console.error('Error refreshing manifest:', error);
            })
            .finally(() => {
                this.setState({ isRefreshLoading: false });
            });
    }

    listGrid_dataBind = (allData) => {
        return allData.map((item, index) => ({
            ...item,
            RowNumber: index + 1
        }));
    };

    getGridData = () => {
        const { endOfDayNickName, selectedFacilityId } = this.state;

        if (!endOfDayNickName || !selectedFacilityId) {
            this.setState({
                gridResourceList: [],
                selectedPrintedItem: 0
            });
            return;
        }

        this.setState({ isGridLoading: true });
        const url = `/WebUI/Shipping/FindOrders/ManifestReprinter?externalId=${endOfDayNickName}&facilityId=${selectedFacilityId}`;

        axios.get(url)
            .then((response) => {
                const gridResourceList = this.listGrid_dataBind(response.data.ResourceList || []);
                this.setState({
                    gridResourceList: gridResourceList,
                    selectedPrintedItem: 0
                });
            })
            .catch((error) => {
                console.error('Error fetching grid data:', error);
                this.setState({
                    gridResourceList: [],
                    selectedPrintedItem: 0
                });
            })
            .finally(() => {
                this.setState({ isGridLoading: false });
            });
    }
    onPrintSelected = () => {
        const reportGrid = $('#endOfDayReportGrid').data('kendoGrid');
        const rows = reportGrid.select();

        rows.each((index, row) => {
            const selectedItem = reportGrid.dataItem(row);
            if (selectedItem && selectedItem.ManifestDownloadLink) {
                const fileName = selectedItem.ManifestDownloadLink.split('/').pop();
                const downloadLink = $("<a class='temp-pdf'>")
                    .attr("href", selectedItem.ManifestDownloadLink)
                    .attr("target", "_blank")
                    .attr("download", fileName)
                    .appendTo("body");

                downloadLink[0].click();
                downloadLink.remove();
            }
        });
    }

    selectRow = (KendoGrid) => {
        const currentSelections = KendoGrid.getNumberOfSelections();
        this.setState({ selectedPrintedItem: currentSelections });
    }
    render() {
        return (
            <WmsModel
                id={"reprintEndOfDayReport"}
                class="reprintEndOfDayReport"
                title={this.translate('Label_Reprint_End_of_Day_Report_Title')}
                width={800}
                onCloseFunc={this.props.onCloseReprintEndOfDayReport}
                height={400}
                isOpen={this.props.sharedIsOpenReprintEndOfDayReport}
                customClass='wms-model-new-ui-wrapper'>
                <div className="model-content-wrapper">
                    <div className="inline-element">
                        <WmsDropdown
                            id="selectedWarehouse"
                            name="selectedWarehouse"
                            label={this.translate('Label_Warehouse_Text')}
                            wmsSelector={this.state.selector + "selectedWarehouse"}
                            value={this.state.selectedWarehouse}
                            onChangeFunc={this.changeWarehouse}
                            options={this.state.faciltyOptions}
                            valueField='name'
                            textField='name'
                            blankFirstOption={true}
                        />
                        <WmsDropdown
                            id="endOfDayNickName"
                            name="endOfDayNickName"
                            label={this.translate('Label_Account_Nick_Name')}
                            wmsSelector={this.state.selector + "endOfDayNickName"}
                            value={this.state.endOfDayNickName}
                            onChangeFunc={this.changeNickName}
                            options={this.state.nickNameOption}
                            valueField='ShipEngineId'
                            textField='NickName'
                            blankFirstOption={false}
                        />
                        <WmsButton
                            label={''}
                            buttonType='green'
                            id='RefreshEndOfDayReport'
                            parentClassName='refresh-btn-wrapper'
                            wmsSelector={this.state.selector + 'refreshEndOfDayReport'}
                            onClickFunc={this.refreshReprintManifest}
                            icon='fa-refresh'
                            loading={this.state.isRefreshLoading}
                            disabled={!this.state.endOfDayNickName || !this.state.selectedFacilityId}
                        />
                    </div>
                    <VirtualGridComponent
                        loading={this.state.isGridLoading}
                        defaultColumns={this.state.gridColumns}
                        allColumns={this.state.gridColumns}
                        schema={{
                            model: {
                                fields: {
                                    createdOn: {
                                        type: 'string'
                                    },
                                    orderCount: {
                                        type: "number"
                                    },
                                    accountNickname: {
                                        type: 'string'
                                    }
                                }
                            }
                        }}
                        gridKeySelection={'RowNumber'}
                        staticGridData={this.state.gridResourceList}
                        virtual={false}
                        showResetButton={false}
                        gridName={"endOfDayReportGrid"}
                        id={"endOfDayReportGrid"}
                        showGridResult={true}
                        showSortColumns={true}
                        showColumnFilter={false}
                        shawCheckbox={false}
                        wmsSelector={this.state.selector + "endOfDayReportGrid"}
                        onSelection={this.selectRow}
                        onSelectAllChange={null}
                        clickEventOfContextMenu={null}
                        emptyRecoredText={window.translate("Window_Title_Label_Empty_Records")}
                        menu={[]}
                        metaDataFieldsName="reprintEndOfDayGrid"
                    />
                </div>
                <div className="footer-btn-holder">
                    <WmsButton
                        id="transferOrderCancel"
                        name="transferOrderCancel"
                        label={this.translate("Label_Cancel")}
                        wmsSelector={this.state.selector + "ButtonCancel"}
                        onClickFunc={this.props.onCloseReprintEndOfDayReport}
                        icon="fa-ban"
                        buttonType="orange"
                        loading={false}
                    />
                    <WmsButton
                        id="printSelected"
                        name="printSelected"
                        label={this.translate('Label_Reprint_EOD_Print_Selected')}
                        wmsSelector={this.state.selector + "printSelected"}
                        onClickFunc={this.onPrintSelected}
                        disabled={this.state.selectedPrintedItem === 0}
                        icon={'fa-print'}
                    />
                </div>
            </WmsModel>
        )
    }
}